import { createFileRoute } from "@tanstack/react-router";
import { useScope } from "@/hooks/use-scope";
import { useImplementationProgress } from "@/lib/implementation-progress";
import {
  TrackPageHeader,
  ChecklistStrip,
  SectionGrid,
  type TrackSection,
} from "@/components/implementation/track-page";

export const Route = createFileRoute("/_authenticated/app/implementation/workspace/operations")({
  component: OperationsTrack,
});

function OperationsTrack() {
  const { tenantId } = useScope();
  const progress = useImplementationProgress(tenantId);
  const track = progress.tracks.operations;

  const sections: TrackSection[] = [
    {
      id: "policies",
      name: "Policies",
      eyebrow: "Decisions, ratified",
      description:
        "Your Blueprint recommends a policy set. Review it, adjust to your business, and ratify. Policies live in the production Policy Library — no implementation-only copy exists.",
      status: "ready",
      actions: [{ label: "Open Policy Library", to: "/app/policies", variant: "primary", icon: "arrow" }],
    },
    {
      id: "carriers",
      name: "Carrier connections",
      eyebrow: "How labels are bought",
      description:
        "Connect the carriers you'll ship with. Rates, labels, tracking, and returns all flow through these connections.",
      status: "ready",
      actions: [{ label: "Manage carriers", to: "/app/admin/carriers", variant: "primary", icon: "arrow" }],
    },
    {
      id: "cart",
      name: "Cart integrations",
      eyebrow: "How orders arrive",
      description:
        "Storefronts, marketplaces, and OMS. Orders and inventory sync through the same Connections surface you'll use forever.",
      status: "ready",
      actions: [{ label: "Open Connections", to: "/app/admin/connections", variant: "primary", icon: "arrow" }],
    },
    {
      id: "billing",
      name: "Billing configuration",
      eyebrow: "How you get paid",
      description:
        "Billable events, rate cards, and customer contracts. Configured once, applied everywhere invoices are generated.",
      status: "ready",
      actions: [{ label: "Open billing", to: "/app/admin/billing-platform", variant: "primary", icon: "arrow" }],
    },
  ];

  return (
    <div>
      <TrackPageHeader
        track={track}
        eyebrow="Track 03 · Operations"
        description="The ratified decisions that govern automated behavior. Each section takes you straight into the production configuration surface — the same one your team will use after go-live."
      />
      <ChecklistStrip track={track} />
      <SectionGrid sections={sections} />
    </div>
  );
}